// extracted by mini-css-extract-plugin
export default {"link":"link_I6skQ","noUnderline":"noUnderline_pCFNw","normal":"normal_gKEUh","dark":"dark_npZAP","white":"white_orEoY","arrow":"arrow_h0DBC"};